const consultar_resumo_de_resultado_finais = [
  {
    path: "/consultar-resumo-de-resultado-finais",
    name: "consultar_resumo_de_resultado_finais",
    meta: {
      allowedPermissions: [
        "processofinal_turma_buscar",
        "processofinal_turmas_pendentes",
        "processofinal_turmas_abertas",
        "processofinal_turmas_fechadas",
        "processofinal_turmas_periodo",
        "processofinal_escola_buscar",
      ],
      breadCrumb:
        "Processo de Resultado Final - Acompanhamento de Resultados Finais",
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeResultadosFinais/ConsultarResumoDeResultadosFinais.vue"
      ),
  },
];

export { consultar_resumo_de_resultado_finais };
